'use client';

import type { TokenInfo } from '@shared/helpers/web3/erc20';

import type { RewardPool } from '@api/types/rewardPools';

import { ListItem } from '../../List/ListItem';
import type { ActionsListProps } from '../types';
import { getTokenNameTitle } from './getTokenNameTitle';
import { SwapButton } from './SwapButton';
import { SwapTypeLabelMap } from './swapTypeLabelMap';
import { useTokenInfoByRewardPoolSettings } from './useTokenInfoByRewardPoolSettings';

const getLabel = (rewardPool: RewardPool, tokenInfo?: TokenInfo): string => {
  if (!rewardPool.distribution_settings) {
    return '';
  }

  const { swap_type } = rewardPool.distribution_settings;
  const swapTypeLabel = SwapTypeLabelMap[swap_type];
  const tokenName = getTokenNameTitle(rewardPool.distribution_settings, tokenInfo);

  return `${swapTypeLabel} ${tokenName} Using Swap`;
};

export const ProrataSwapActionsList = ({ rewardPool, locked }: ActionsListProps) => {
  const { tokenInfo, isTokenLoading } = useTokenInfoByRewardPoolSettings(rewardPool);
  const label = getLabel(rewardPool, tokenInfo);

  return (
    <ListItem
      key={rewardPool.id}
      isLoading={isTokenLoading}
      data-qa={`swap_action_${rewardPool.id}`}
      isDisabled={locked}
      label={label}
      description="The higher the swap volume, the greater your reward."
      buttons={<SwapButton rewardPool={rewardPool} locked={locked} isLoading={isTokenLoading} />}
    />
  );
};
